import { connect } from 'react-redux';

import HomeFeedLogisticsModal from '../../components/HomeFeedLogisticsModal';

import { toggleDateTimeModal, toggleLogisticsModal } from '../../actions/homeFeedActions';
import { trackViewedLogisticsControl } from '../../actions/tracking/filters';
import {
  getCityName,
  getDateTimeLabel,
  getNeighborhood,
  getPostcode,
  getHasMultipleFulfillmentMethods,
  getHasFulfillmentTimeMethod,
} from '../../selectors/homeSelectors';
import { isFeatureActive } from '../../selectors/configSelectors';
import { showLocationSearchModal } from '../../actions/locationActions';
import { CO_CLICK_AND_COLLECT } from '../../flags/features';

const mapStateToProps = (state) => ({
  city: getCityName(state),
  dateTimeLabel: getDateTimeLabel(state),
  neighborhood: getNeighborhood(state),
  postcode: getPostcode(state),
  isChangeTimeAllowed: getHasFulfillmentTimeMethod(state),
  withClickAndCollect: isFeatureActive(state, CO_CLICK_AND_COLLECT),
  showFulfillmentSwitchControl: getHasMultipleFulfillmentMethods(state),
});

const mapDispatchToProps = (dispatch) => ({
  showLocationSearchModal: () => dispatch(showLocationSearchModal()),
  toggleDateTimeModal: (isOpen) => dispatch(toggleDateTimeModal(isOpen)),
  trackViewedLogisticsControl: () => dispatch(trackViewedLogisticsControl('restaurant list')),
  onClose: () => dispatch(toggleLogisticsModal(false)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeFeedLogisticsModal);
